export const EXCMRELATIONUSERDATA_SHOW_RESET = 'EXCMRELATIONUSERDATA_SHOW_RESET'
export const EXCMRELATIONUSERDATA_SHOW_SET_ERROR = 'EXCMRELATIONUSERDATA_SHOW_SET_ERROR'
export const EXCMRELATIONUSERDATA_SHOW_SET_RETRIEVED = 'EXCMRELATIONUSERDATA_SHOW_SET_RETRIEVED'
export const EXCMRELATIONUSERDATA_SHOW_TOGGLE_LOADING = 'EXCMRELATIONUSERDATA_SHOW_TOGGLE_LOADING'
